import { SettingApi } from '@/api/setting';
import { snackbarProgrammatic } from '@/components/snackbar';
import { SystemSetting } from '@/shared/system-setting';
import { State } from '@/stores/settings/state';
import { ActionContext, ActionTree } from 'vuex';

const api = new SettingApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public loadSystemSettingsAsync = async (context: ActionContext<State, any>) => {
        const systemSettings = await api.getSettingsAsync();
        context.commit('setSystemSettings', systemSettings);
    }

    public updateSystemSettingAsync = async (context: ActionContext<State, any>, systemSetting: SystemSetting) => {
        try {
            await api.updateSettingAsync({ ...systemSetting });
        } catch (e) {
            snackbarProgrammatic.open({ message: `Could not update the system setting. ${e.message}`, type: 'is-danger' });
        }
    }
}
